<template>
  <v-layout row wrap>
    <v-flex xs10 offset-xs1><v-divider /></v-flex>
    <v-flex xs10 offset-xs1>
      <v-card flat>
        <div class="pt-4 text-xs-center">
          <div class="headline">
            Qualifications
          </div>
        </div>

        <v-tabs-items v-model="slide">
          <v-tab-item
            v-for="(qualification, i) in sortedQualifications"
            :key="`qualification-${i}`"
            @click="nextSlide"
          >
            <Qualification
              :profile="profile"
              :qualification="qualification"
              :flags="getFlags(qualification)"
              :requiresProofOfRegistration="requiresProofOfRegistration(qualification.id)"
              :requiresQualificationTranscript="requiresQualificationTranscript(qualification.id)"
              @refresh="$emit('refresh')"
            />
          </v-tab-item>
        </v-tabs-items>

        <v-tabs v-model="slide" slider-color="transparent" centered>
          <v-tab v-for="(qualification, i) in sortedQualifications" :key="`qualification-${i}`">
            <v-icon small>mdi-school</v-icon>
          </v-tab>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
// Components
import Qualification from '@/components/client/candidate/profile/qualifications/Qualification'

// Helpers
import _ from 'lodash'
import { byEndsAt, byLevels } from '@/sorting/ProfileQualification'
import { mode } from 'simple-statistics'

export default {
  components: { Qualification },

  created() {
    if (this.sortedQualifications && this.sortedQualifications[0]) {
      this.selected = this.sortedQualifications[0].id
    }
  },

  props: { profile: Object, actionItems: Array },

  data() {
    return {
      slide: 0,
    }
  },

  computed: {
    qualifications() {
      if (!this.profile || !this.profile.profileQualifications) return []

      return this.profile.profileQualifications
    },

    sortedQualifications() {
      if (!this.qualifications || !this.qualifications[0]) return []

      const qualifications = JSON.parse(JSON.stringify(this.qualifications))

      return qualifications
        .sort(byEndsAt({ asc: false }))
        .sort(byLevels({ country: this.levelsCountryMode(), asc: false }))
    },
  },
  methods: {
    getFlags(qualification) {
      const flags = _.get(this, 'profile.flags')

      if (!flags) return []

      return flags.filter(f => {
        return f.targetId === qualification.id && f.targetType === 'ProfileQualification'
      })
    },

    nextSlide() {
      if (this.slide + 1 < this.qualifications.length) return this.slide++
      return (this.slide = 0)
    },

    levelsCountryMode() {
      const countries = this.qualifications
        .filter(pq => pq.qualification && pq.qualification.levels && pq.qualification.levels[0])
        .reduce(
          (acc, { qualification: { levels } }) => acc.concat(levels.map(l => l.countryCode)),
          []
        )
      return countries[0] ? mode(countries) : null
    },

    requiresProofOfRegistration(id) {
      if (this.actionItems) {
        return this.actionItems.some(
          a => a.type === 'ActionItem::Registration' && a.target.id === id
        )
      }
      return false
    },

    requiresQualificationTranscript(id) {
      if (this.actionItems) {
        return this.actionItems.some(a => a.type === 'ActionItem::Transcript' && a.target.id === id)
      }
      return false
    },
  },
}
</script>
